import { Node, mergeAttributes } from '@tiptap/core';

export const createImplantConditionsBlockExtension = () =>
    Node.create({
        name: 'implantConditionsBlock',
        group: 'block',
        content: 'block*',
        parseHTML() {
            return [
                {
                    tag: 'div[id^="implant-conditions-"]',
                    getAttrs: (node) => {
                        if (typeof node === 'string') return false;
                        const id = (node as HTMLElement).getAttribute('id');
                        if (!id) return false;
                        return { implantId: id };
                    },
                },
            ];
        },
        addAttributes() {
            return {
                implantId: {
                    default: null,
                    parseHTML: (element) => element.getAttribute('id'),
                    renderHTML: (attributes) => {
                        if (!attributes.implantId) return {};
                        return { id: attributes.implantId };
                    },
                },
            };
        },
        renderHTML({ HTMLAttributes }) {
            return ['div', mergeAttributes(HTMLAttributes), 0];
        },
    });
